import React, { useState } from 'react';
import { useMakes } from '../../../../../../Hooks/TT_ELD/Makes-Models';
import MakeTable from './MakeTable';
import { Button, TableProps } from 'antd';
import AddMakeList from './AddMakeList';
import SearchInput from '../../../../../../Utils/SearchInput';
import useRouteQuery from '../../../../../../Utils/useRouterQuery';
import { TableParams } from '../../../../../../Utils/TableTypes';
import { useTagQuerySync } from '../../../../../../Utils/useTagQuerySync';

const Makes = () => {
  const showModal = () => {
    setOpen(true);
  };
  const [open, setOpen] = useState(false);
  const [makeName, setMakeName] = useRouteQuery('', 'makeName', (v) => String(v));

  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  useTagQuerySync(
    { en_US: 'Makes', zh_CN: '' },
    'makes',
    { makeName, tableParams },
    { makeName: setMakeName, tableParams: setTableParams },
  );

  const { data, isLoading, isFetching, refetch } = useMakes(makeName, tableParams);

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      makeName: setMakeName,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setTableParams({
        pagination: {
          current: 1,
        },
      });
    }
  };

  const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };

  return (
    <div className="mainPage">
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {open && <AddMakeList open={open} setOpen={setOpen} refetch={refetch} />}
        <SearchInput
          value={makeName}
          placeholder="Search by make"
          onDebounceChange={(event: string) => handleChange(event, 'makeName')}
        />
        <Button type="primary" style={{ marginLeft: 'auto' }} size={'large'} onClick={showModal}>
          Add Make
        </Button>
        <Button size={'large'} style={{ marginLeft: '15px' }} onClick={() => refetch()}>
          Refresh
        </Button>
      </span>
      <MakeTable
        make={data?.data}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={refetch}
        handleTableChange={handleTableChange}
        tableParams={tableParams}
      />
    </div>
  );
};

export default Makes;
